import { ReactComponent as EllipsisSVG } from './SVG/ellipsis.svg'

export function Ellipsis({ color = '#d5d5d5' }) {

    return (
        <EllipsisSVG fill={color} stroke={color} className="pointer" />
    )
}